import { fetchWithCache, getCachedData } from "../services/apiService";

export const getActiveProfilePromotions = async (property_id) => {
  const cacheKey = `/api/promotion/active_${property_id}`;

  // Return cached data immediately if available
  const cached = getCachedData(cacheKey, {});

  try {
    const data = await fetchWithCache(
      "/api/promotion/active",
      {
        method: "GET",
        params: { property_id },
        cacheKey,
        retries: 2,
        timeout: 10000,
      },
      true,
    );
    return data || [];
  } catch (error) {
    return cached || [];
  }
};
